module.exports = __webpack_public_path__ + "img/contracts-vector.97a2ad5b.svg";